<template>
  <div class="my-0 text-center">
    <h1 class="mb-1">Topics</h1>
    <div class="mb-4">Let us know a few topics that you care about.</div>
    <div class="text-left">
      <div
        v-for="(mainTopic, topicNdx) in mainTopics"
        :key="mainTopic"
        class="md:grid md:grid-cols-3 md:gap-6 p-2"
        :class="{ hilight: topicNdx % 2 === 0, 'mt-5': topicNdx > 0 }"
      >
        <div class="md:col-span-1">
          {{ getHeadingFor(mainTopic) }}
        </div>
        <div class="md:col-span-2 mt-5 md:mt-0">
          <button
            v-on:click="selectTopic(mainTopic)"
            class="bg-primaryLight text-black text-center p-2 m-1 text-xl outline-none border-2"
            v-bind:class="{
              selectedBtn: selection[mainTopic],
              unselectedBtn: !selection[mainTopic],
            }"
          >
            {{ getHeadingFor(mainTopic) }} (general)
          </button>
          <button
            v-for="relTopic in relatedTopics(mainTopic)"
            :key="relTopic"
            v-on:click="selectTopic(relTopic)"
            class="bg-primaryLight text-black text-center p-2 m-1 text-xl outline-none border-2"
            v-bind:class="{
              selectedBtn: selection[relTopic],
              unselectedBtn: !selection[relTopic],
            }"
          >
            {{ getHeadingFor(relTopic) }}
          </button>
        </div>
      </div>

      <!--
      <div class="md:grid md:grid-cols-3 md:gap-6 p-2 hilight">
        <div class="md:col-span-1">
          Let us know topics that you care about.
        </div>
        <div class="md:col-span-2 mt-5 md:mt-0">
          <button v-for="feedKey in feedKeys" :key="feedKey"
              v-on:click="selectTopic(feedKey)"
              class="bg-primaryLight text-black text-center p-2 m-1 text-xl outline-none border-2"
              v-bind:class="{ selectedBtn: selection[feedKey], unselectedBtn: !selection[feedKey] }"
              >
            {{ getHeadingFor(feedKey) }}
          </button>
        </div>
      </div>
      -->

      <div class="md:grid md:grid-cols-3 md:gap-6 mt-5 p-2">
        <div class="md:col-span-1"></div>
        <div class="md:col-span-2 mt-5 md:-mt-4">
          <button class="ctrl btn mt-4" v-on:click="createAcct">
            {{ createBtnTxt }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.hilight {
  @apply bg-gray-100;
}
.ctrl {
  @apply block mt-2;
}
.btn {
  @apply bg-primaryColor text-white p-4;
}
.btn:hover {
  @apply underline;
}
.selectedBtn {
  @apply border-red-500;
}
.unselectedBtn {
  @apply border-primaryLink;
}
</style>

<script>
import fc from '@/feed-config';
import utils from '@/services/utils';
// import twitterAuth from '@/services/twitterAuth';

export default {
  name: 'onboard-user',
  data() {
    return {
      selection: {},
      mainTopics: ['marketing', 'sales', 'product', 'startups'],
      createBtnTxt: 'Create Account',
    };
  },
  // computed: {
  //   feedKeys() {
  //     return fc.allTopicKeys();
  //   },
  // },
  methods: {
    relatedTopics(topic) {
      // console.log('relatedTopics: ', topic);
      const topicInfo = fc.feedInfoFromTopicKey(topic);
      if (topicInfo && topicInfo.relatedKeys) return topicInfo.relatedKeys;
      return [];
    },
    selectTopic(topic) {
      console.log('selectTopic: ', topic);
      this.selection[topic] = !this.selection[topic];
    },
    getHeadingFor(feedKey) {
      // console.log(`getHeadingFor(${feedKey})`);
      const topicInfo = fc.feedInfoFromTopicKey(feedKey);
      if (topicInfo) return topicInfo.heading;
      return `FeedInfo not found: ${feedKey}`;
    },
    async createAcct() {
      utils.log('createAcct clicked');
    },
  },
  created() {
    // intentionally don't set (add) properties directly on
    // selection - otherwise reactivity is not added
    const initSelVal = {};
    fc.allTopicKeys().forEach((topic) => {
      initSelVal[topic] = false;
    });
    this.selection = initSelVal;
  },
};
</script>
